import { FC } from 'react';
import { BsLightningCharge } from '@react-icons/all-files/bs/BsLightningCharge';
import classNames from 'classnames';

import { BottomSheet } from 'components/design-system/BottomSheet';
import { Button } from 'components/design-system/Button';
import { intercomShowNewMessage } from 'lib/intercom';

const items = [
  {
    title: '3x',
    text: 'Faster sale conversion'
  },
  {
    title: <BsLightningCharge className='text-primary' />,
    text: 'Prominently featured'
  },
  {
    title: (
      <span>
        <span>24</span>
        <span className='letter-spacing-08 fs-10px'>HRS</span>
      </span>
    ),
    text: 'Interested buyers only'
  }
];

export type FinalOfferInfoBottomSheetProps = {
  onBack: () => void;
};

export const FinalOfferInfoBottomSheet: FC<FinalOfferInfoBottomSheetProps> = ({ onBack }) => (
  <BottomSheet onBack={onBack} className='pb-5'>
    <div className='d-flex flex-column align-items-center text-center'>
      <div
        className='border-radius-24 d-flex justify-content-center align-items-center bg-lightGreen mb-3'
        style={{ height: 36, width: 36 }}
      >
        <BsLightningCharge className='text-success' />
      </div>
      <h4 className='fs-20px line-height-32px letter-spacing-007'>Final Offer Boosts</h4>
      <div className='mt-3 fs-16px riforma-regular letter-spacing-006'>
        <div className='opacity-60'>
          We’ll take the price you last countered at and show it to a set of buyers that have shown interest in that
          model for 24 hours
        </div>
      </div>
      <div className='d-flex justify-content-between my-4'>
        {items.map(({ text, title }, index) => (
          <div key={text} className={classNames({ 'border-end': index !== items.length - 1 })}>
            <div
              className='d-flex align-items-center fs-20px justify-content-center riforma-regular'
              style={{ minHeight: 32 }}
            >
              {title}
            </div>
            <div className='fs-12px opacity-60'>{text}</div>
          </div>
        ))}
      </div>
      <Button variant='secondary' onClick={intercomShowNewMessage} className='w-100 mb-4 py-3'>
        Ask us a question
      </Button>
    </div>
  </BottomSheet>
);
